export default "/assets/images/the-big-sneeze.f2bdd6def3c82bf9.webp";